<form [formGroup]="noteEntryForm">
    <!--This should be using validation component.-->
    <div class="mvd_alert--container open" *ngIf="showErrorTable">
        <div class="mvd_alert--results" id="errorTable">
            <h2 class="mvd_alert--header">Alerts <button class="close" type="button" (click)="cancelNoteEntry()">&times;</button></h2>
            <ul class="mvd_alert__group">
                <li class="mvd_alert--error" *ngFor="let e of errors">
                    <strong>Error -</strong>
                    {{ e }}
                </li>
            </ul>
        </div>
    </div>
    <br />
    <h2>Note</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-12 mvd_form-group">
                <label>Note Message</label>
                <textarea class="mvd_form-control" id="noteDescriptionInput" cols="65" rows="4" formControlName="noteDescription"></textarea>
                <div class="mvd_alert__validation" *ngIf="noteEntryForm.get('noteDescription')?.hasError('maxlength')">
                    <div class="mvd_alert__rule">Note has a maximum length of {{ noteEntryForm.get('noteDescription')?.errors['maxlength'].requiredLength }} characters</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 mvd_form-group" *ngIf="!note.parentId">
                <label class="mvd_label--inline">
                    <input type="checkbox" id="confidentialInput" formControlName="isConfidential" /> Confidential
                </label>
                <label class="mvd_label--inline" *ngIf="isOIGFraudNoteClaim">
                    <input type="checkbox" id="OIGFraudInput" formControlName="isOIGFraud" /> OIG Fraud
                </label>
            </div>
            <div class="col-sm-6 mvd_form-group">
                <div class="btn--group">
                    <button class="btn--default" type="button" (click)="cancelNoteEntry()">Cancel</button>
                    <mvm-spinner-btn [isDisabled]="!noteEntryForm.valid" [isLoading]="showButtonLoading" btnText="Save" (clicked)="saveNote()"></mvm-spinner-btn>
                </div>
            </div>
        </div>
    </fieldset>
</form>